module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RS_ALL.0181c220.jpg";